import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'
import { getCookieConsentValue } from './CookieConsent'

export default function GATracker() {
  const location = useLocation()

  // On mount — init GA4 if consent was already given on a previous visit
  useEffect(() => {
    const consent = getCookieConsentValue('corpstage_cookie_consent')
    const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID
    if (consent === 'true' && gaId && gaId !== 'G-XXXXXXXXXX') {
      try { ReactGA.initialize(gaId) } catch (e) { console.warn('GA init failed', e) }
    }
  }, [])

  // Track every page view
  useEffect(() => {
    const consent = getCookieConsentValue('corpstage_cookie_consent')
    if (consent === 'true') {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
      })
    }
  }, [location])

  return null
}
